import { Box } from '@mui/material';
import React, { useState } from 'react';

import { borderRadius, palette, spaces } from '../../../../assets/styles/themes/tokens';

interface ArtifactCardImageContentProps {
	presignedUrl: string;
	title: string;
}

const contentBoxSx = {
	margin: `0 ${spaces.md}`,
	flex: 1,
	overflow: 'hidden',
	border: `1px solid ${palette.elevation.outlined}`,
	borderRadius: `${borderRadius.sm} ${borderRadius.sm} 0 0`,
};

const imageSx = {
	width: '100%',
	height: '100%',
	objectFit: 'cover' as const,
	display: 'block',
};

const ArtifactCardImageContent: React.FC<ArtifactCardImageContentProps> = ({
	presignedUrl,
	title,
}) => {
	const [hasError, setHasError] = useState(false);

	if (hasError) return null;

	return (
		<Box data-testid="artifact-card-image-content" sx={contentBoxSx}>
			<Box
				component="img"
				src={presignedUrl}
				alt={title}
				loading="lazy"
				onError={() => setHasError(true)}
				sx={imageSx}
			/>
		</Box>
	);
};

export default ArtifactCardImageContent;
